import { Component, OnInit, Input, ViewChild, ChangeDetectorRef,HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseService } from '../../../shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { DialogConfig } from '../../dialog/dialog-config';

@Component({
    selector: 'pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styleUrls: ['./pdf-viewer.component.scss'],
    standalone: false
})
export class PDFViewerComponent implements OnInit {
  @Input() config: any = {};
  @Input() isBlob: boolean = false;
  @ViewChild('pdfViewer') public pdfViewer;
  constructor(
    private baseService: BaseService,
    private loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    public dialogConfig: DialogConfig
  ) { }

  ngOnInit() {
    if (Object.keys(this.config).length === 0 &&  this.dialogConfig != undefined && this.dialogConfig['data'] && this.dialogConfig['data'] != null && this.dialogConfig.popupConfig == undefined) {
      this.config = this.dialogConfig.data;
      this.isBlob = this.config.isBlob != undefined ? this.config.isBlob : this.isBlob;
    }
    if(this.config.print == undefined)
      this.config.print = true;
  }
  @HostListener('window:keydown', ['$event'])
  handleGlobalKeydown(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'p') {
      event.preventDefault(); 

      this.focusPdfViewerIframe(); 

      // ✅ Simulate Ctrl+P inside iframe
      const iframe = this.pdfViewer?.iframe?.nativeElement;
      if (iframe?.contentWindow) {
        const keyEvent = new KeyboardEvent('keydown', {
          key: 'p',
          ctrlKey: true,
          //bubbles: true,
        });
        iframe.contentWindow.document.dispatchEvent(keyEvent);
      }
    }
  }
  ngAfterViewInit() {
    if (this.isBlob) {
      this.pdfViewer.pdfSrc = this.config.blob;
      this.pdfViewer.refresh();
    }
    this.cdr.detectChanges();
   
  
  }
  
  focusPdfViewerIframe() {
    console.log(this.pdfViewer.iframe)
    let iframe=this.pdfViewer.iframe ;
    console.log("focus set on",iframe)
    
    if (iframe ) {
      const pdfDocument = iframe.nativeElement.contentDocument;

      pdfDocument.body.click(); // tricks browser into enabling focus-based actions
    
      // Then focus the iframe
      // iframe.nativeElement.contentWindow.focus();
    
            // pdfDocument.body.focus();
    
          }
  }
  ngOnChanges() {
    if (!this.isBlob)
      this.getFile();
  }

  getFile() {
    this.loaderService.showSpinner();
    this.baseService.getFileByUrl(this.config.url, false).subscribe(
      (res) => {
        this.loaderService.hideSpinner();
        this.pdfViewer.pdfSrc = res; // pdfSrc can be Blob or Uint8Array
        this.pdfViewer.refresh(); // Ask pdf viewer to load/refresh pdf
      }, (err) => {
        this.loaderService.hideSpinner();
      }
    );
  }
}
